import React from 'react';
import { ParticipantHubLayout } from './ParticipantHubLayout';
import { motion } from 'framer-motion';
import { RadioIcon, ClockIcon, MapPinIcon, MessageSquareIcon, SparklesIcon, BarChartIcon, ArrowRightIcon } from 'lucide-react';
export function LiveCompanionPage() {
  return <ParticipantHubLayout data-id="element-4761">
      <div className="p-6 lg:p-8 max-w-6xl mx-auto space-y-6" data-id="element-4762">
        {/* Live Header */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-4763">
          <div data-id="element-4764">
            <div className="flex items-center gap-2 mb-2" data-id="element-4765">
              <span className="relative flex h-3 w-3" data-id="element-4766">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-400 opacity-75" data-id="element-4767"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-rose-500" data-id="element-4768"></span>
              </span>
              <span className="text-xs font-bold text-rose-600 tracking-wider uppercase" data-id="element-4769">
                Live Now
              </span>
              <span className="text-xs font-medium text-slate-400 ml-2" data-id="element-4770">
                SESSION 3 OF 8
              </span>
            </div>
            <h1 className="font-serif-display text-4xl text-slate-900" data-id="element-4771">
              AI Integration Frameworks
            </h1>
          </div>
          <div className="flex items-center gap-3 bg-white px-4 py-2 rounded-xl border border-slate-200 shadow-sm" data-id="element-4772">
            <ClockIcon className="w-4 h-4 text-amber-500" data-id="element-4773" />
            <span className="text-sm font-bold text-slate-700" data-id="element-4774">
              45 mins remaining
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-4775">
          {/* Main Content Area */}
          <div className="lg:col-span-2 space-y-6" data-id="element-4776">
            {/* Session Info Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm" data-id="element-4777">
              <div className="flex items-start justify-between mb-6" data-id="element-4778">
                <div data-id="element-4779">
                  <h2 className="text-lg font-bold text-slate-900 mb-1" data-id="element-4780">
                    Operationalizing AI in Q4
                  </h2>
                  <div className="flex items-center gap-4 text-sm text-slate-500" data-id="element-4781">
                    <span className="flex items-center gap-1" data-id="element-4782">
                      <MapPinIcon className="w-4 h-4" data-id="element-4783" />
                      Grand Ballroom B
                    </span>
                    <span data-id="element-4784">Facilitator: Dr. Sarah Chen</span>
                  </div>
                </div>
                <div className="w-12 h-12 rounded-full bg-slate-100 overflow-hidden" data-id="element-4785">
                  <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=200&q=80" alt="Facilitator" className="w-full h-full object-cover" data-id="element-4786" />
                </div>
              </div>

              {/* Note Taking Area */}
              <div className="bg-slate-50 rounded-xl border border-slate-200 p-4" data-id="element-4787">
                <textarea placeholder="Take a private note... (Saved automatically to your Action Plan)" className="w-full h-32 bg-transparent border-none resize-none focus:ring-0 text-slate-700 placeholder:text-slate-400 text-sm" data-id="element-4788" />
                <div className="flex justify-between items-center mt-2 pt-2 border-t border-slate-200" data-id="element-4789">
                  <span className="text-xs text-slate-400" data-id="element-4790">Saved just now</span>
                  <button className="text-sm font-medium text-amber-600 hover:text-amber-700" data-id="element-4791">
                    Expand Editor
                  </button>
                </div>
              </div>
            </motion.div>

            {/* AI Companion Chat */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="bg-[#0B1B3B] rounded-2xl p-6 shadow-lg text-white" data-id="element-4792">
              <div className="flex items-center gap-2 mb-4" data-id="element-4793">
                <SparklesIcon className="w-5 h-5 text-amber-400" data-id="element-4794" />
                <h3 className="font-serif-display text-xl" data-id="element-4795">
                  Ask the AI Companion
                </h3>
              </div>
              <p className="text-sm text-slate-300 mb-4" data-id="element-4796">
                Ask questions about the current framework, request examples, or
                get context from the pre-reads.
              </p>
              <div className="relative" data-id="element-4797">
                <input type="text" placeholder="E.g., How does this apply to the engineering team?" className="w-full bg-white/10 border border-white/20 rounded-xl py-3 pl-4 pr-12 text-sm text-white placeholder:text-slate-400 focus:outline-none focus:border-amber-400 transition-colors" data-id="element-4798" />
                <button className="absolute right-2 top-1/2 -translate-y-1/2 p-2 bg-amber-500 rounded-lg text-[#0B1B3B] hover:bg-amber-400 transition-colors" data-id="element-4799">
                  <ArrowRightIcon className="w-4 h-4" data-id="element-4800" />
                </button>
              </div>
            </motion.div>
          </div>

          {/* Sidebar */}
          <div className="space-y-6" data-id="element-4801">
            {/* Live Poll */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm" data-id="element-4802">
              <div className="flex items-center gap-2 mb-4" data-id="element-4803">
                <BarChartIcon className="w-5 h-5 text-amber-500" data-id="element-4804" />
                <h3 className="font-bold text-slate-900" data-id="element-4805">Live Poll</h3>
              </div>
              <p className="text-sm text-slate-700 mb-4 font-medium" data-id="element-4806">
                What is your biggest barrier to AI adoption?
              </p>
              <div className="space-y-3" data-id="element-4807">
                {[{
                label: 'Data Privacy / Security',
                percent: 45
              }, {
                label: 'Lack of Internal Skills',
                percent: 30
              }, {
                label: 'Unclear ROI',
                percent: 15
              }, {
                label: 'Other',
                percent: 10
              }].map((option, i) => <div key={i} className="relative" data-id="element-4808">
                    <div className="flex justify-between text-xs font-medium mb-1 relative z-10 px-2" data-id="element-4809">
                      <span className="text-slate-700" data-id="element-4810">{option.label}</span>
                      <span className="text-slate-500" data-id="element-4811">{option.percent}%</span>
                    </div>
                    <div className="h-8 bg-slate-50 rounded-lg overflow-hidden absolute inset-0" data-id="element-4812">
                      <div className="h-full bg-amber-100 rounded-lg transition-all duration-1000" style={{
                    width: `${option.percent}%`
                  }} data-id="element-4813" />
                    </div>
                  </div>)}
              </div>
              <div className="mt-4 text-center text-xs text-slate-400" data-id="element-4814">
                28 of 32 participants have voted
              </div>
            </motion.div>

            {/* Up Next */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3
          }} className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm" data-id="element-4815">
              <h3 className="font-bold text-slate-900 mb-4" data-id="element-4816">Up Next</h3>
              <div className="space-y-4" data-id="element-4817">
                <div className="flex gap-3" data-id="element-4818">
                  <div className="text-xs font-bold text-slate-400 w-12 pt-0.5" data-id="element-4819">
                    11:30
                  </div>
                  <div data-id="element-4820">
                    <div className="text-sm font-bold text-slate-900" data-id="element-4821">
                      Coffee Break
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-4822">Terrace</div>
                  </div>
                </div>
                <div className="flex gap-3" data-id="element-4823">
                  <div className="text-xs font-bold text-slate-400 w-12 pt-0.5" data-id="element-4824">
                    11:45
                  </div>
                  <div data-id="element-4825">
                    <div className="text-sm font-bold text-slate-900" data-id="element-4826">
                      Breakout: Department Planning
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-4827">Various Rooms</div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </ParticipantHubLayout>;
}